import { Avatar, Box, Button, Drawer } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import logoKappaMobile from "../img/kappaLogoMobile.png";

interface menuPages {
  currentPage?: string;
}

const HeaderMobile: React.FC<menuPages> = ({ currentPage }) => {
  const [user, setUser] = useState<any>("");
  const navigate = useNavigate();

  const page = currentPage ?? null;

  const handledevolution = () => {
    navigate("/devolution");
  };
  const handleNewQuery = () => {
    navigate("/order");
  };
  const handleInfo = () => {
    navigate("/info");
  };

  const handlelogout = () => {
    localStorage.removeItem("auth");
    window.location.href = "/";
  };

  const [open, setOpen] = useState(false);

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("auth") || "{}");
    setUser(user);
  }, []);

  return (
    <Box>
      <Box display={"flex"} alignItems={"center"} borderBottom={"2px solid #E3E3E3"} py={2} mb={2}>
        <Button onClick={toggleDrawer(true)}>
          <svg width="22" height="15.889" viewBox="0 0 22 15.889" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M1.222 15.49a1.2 1.2 0 0 1-.87-.352 1.2 1.2 0 0 1-.352-.87q0-.521.352-.871a1.2 1.2 0 0 1 .87-.351h19.556q.518 0 .87.351.352.352.352.871 0 .518-.352.87a1.2 1.2 0 0 1-.87.352zm0-6.111a1.2 1.2 0 0 1-.87-.352A1.2 1.2 0 0 1 0 8.157q0-.521.352-.871a1.2 1.2 0 0 1 .87-.351h19.556q.518 0 .87.351.352.352.352.871 0 .518-.352.87a1.2 1.2 0 0 1-.87.352zm0-6.111a1.2 1.2 0 0 1-.87-.352A1.2 1.2 0 0 1 0 2.046q0-.521.352-.873a1.2 1.2 0 0 1 .87-.349h19.556q.518 0 .87.351.352.352.352.871 0 .518-.352.87a1.2 1.2 0 0 1-.87.352z"
              fill="#1C1B1F"
            />
          </svg>
        </Button>
        <Box width={200} margin={"0 auto"}>
          <img src={logoKappaMobile} style={{ width: "100%" }} />
        </Box>
      </Box>

      <Drawer
        open={open}
        onClose={toggleDrawer(false)}
        PaperProps={{
          sx: { width: "100%" },
        }}>
        <Box display={"flex"} flexDirection={"column"} alignItems={"center"}>
          {/* header */}
          <Box
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"center"}
            alignItems={"center"}
            borderBottom={"1px solid #ccc"}
            width={"100%"}
            paddingY={4}>
            <img src={logoKappaMobile} style={{ width: 250 }} />
            <Button onClick={toggleDrawer(false)} sx={{ position: "fixed", right: 0, top: 45, color: "#000", fontWeight: 700, fontSize: 22 }}>
              <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="m12.5 14.418-8.75 8.75a1.7 1.7 0 0 1-1.25.491 1.7 1.7 0 0 1-1.25-.491 1.7 1.7 0 0 1-.491-1.25q0-.759.491-1.25l8.75-8.75-8.75-8.75a1.7 1.7 0 0 1-.491-1.25q0-.761.491-1.25A1.7 1.7 0 0 1 2.5.177q.759 0 1.25.491l8.75 8.75 8.75-8.75A1.7 1.7 0 0 1 22.5.177q.759 0 1.25.491a1.7 1.7 0 0 1 .491 1.25 1.7 1.7 0 0 1-.491 1.25L15 11.918l8.75 8.75a1.7 1.7 0 0 1 .491 1.25 1.7 1.7 0 0 1-.491 1.25 1.7 1.7 0 0 1-1.25.491 1.7 1.7 0 0 1-1.25-.491z"
                  fill="#1C1B1F"
                />
              </svg>
            </Button>
          </Box>
          {/* header */}

          {/* user */}
          <Box display={"flex"} flexDirection={"column"} alignItems={"center"} mt={5} gap={1}>
            <Avatar sx={{ width: 60, height: 60 }}>{user?.name?.split(" ")[0][0]}</Avatar>
            <p style={{ fontSize: 19 }}>
              Olá, <span style={{ fontWeight: 700 }}>{user?.name?.split(" ")[0]}!</span>
            </p>
            <p style={{ fontSize: 19 }}>{user?.email}</p>
          </Box>
          {/* user */}

          {/* links */}
          <Box display={"flex"} flexDirection={"column"} mt={5} width={"90%"}>
            <button onClick={handledevolution} style={{ border: "none", background: "none", cursor: "pointer" }}>
              <div className={`menuItem ${page === "devolution" ? "currentPage" : null}`} style={{ width: "90%" }}>
                <p style={{ fontSize: 19 }}>Acompanhar Solicitação</p>
              </div>
            </button>
            <button onClick={handleNewQuery} style={{ border: "none", background: "none", cursor: "pointer" }}>
              <div className={`menuItem ${page === "request" ? "currentPage" : null}`} style={{ width: "90%" }}>
                <p style={{ fontSize: 19 }}>Nova Solicitação</p>
              </div>
            </button>
            <button onClick={handleInfo} style={{ border: "none", background: "none", cursor: "pointer" }}>
              <div className={`menuItem ${page === "info" ? "currentPage" : null}`} style={{ width: "90%" }}>
                <p style={{ fontSize: 19 }}>Informações e Instruções</p>
              </div>
            </button>
          </Box>
          {/* links */}

          {/* sair */}
          <Button style={{ position: "fixed", bottom: 25 }} onClick={handlelogout}>
            <Box display={"flex"} flexDirection={"row"} alignItems={"center"} gap={1}>
              <svg width="22" height="23.222" viewBox="0 0 22 23.222" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M2.893 22.962q-1.008 0-1.727-.719a2.38 2.38 0 0 1-.717-1.726V3.406q0-1.008.717-1.727A2.38 2.38 0 0 1 2.893.962h7.333q.518 0 .87.351.352.352.352.871 0 .518-.352.87a1.2 1.2 0 0 1-.87.352H2.893v17.111h7.333q.518 0 .87.351.352.352.352.871 0 .518-.352.87a1.2 1.2 0 0 1-.87.352zm14.881-9.778H9.005a1.2 1.2 0 0 1-.871-.352 1.2 1.2 0 0 1-.351-.87q0-.519.351-.871a1.2 1.2 0 0 1 .871-.351h8.769l-2.292-2.292a1.12 1.12 0 0 1-.336-.825q0-.489.336-.856a1.16 1.16 0 0 1 .856-.383 1.16 1.16 0 0 1 .886.352l4.369 4.369q.367.367.367.856t-.367.856l-4.369 4.369a1.14 1.14 0 0 1-.871.351 1.25 1.25 0 0 1-.87-.381 1.2 1.2 0 0 1-.321-.871 1.2 1.2 0 0 1 .352-.84z"
                  fill="#1C1B1F"
                />
              </svg>
              <p style={{ fontSize: 19, color: "#000" }}>| Sair</p>
            </Box>
          </Button>
          {/* sair */}
        </Box>
      </Drawer>
    </Box>
  );
};
export default HeaderMobile;
